module.exports = __webpack_public_path__ + "static/media/Icons_training.9a6d5dbf.svg";